export default __webpack_public_path__ + "static/chandni-fc46a79f6247a67b61d21277afaa05c1.jpg";